var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnimateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "12px",
    viewBox: "0 0 19 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-270.000000, -3123.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-animate-right",
    transform: "translate(270.000000, 3123.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.71428571,6 C1.71428571,8.537469 3.092555,10.753026 5.14130211,11.9388794 C2.23435588,11.5224089 4.89386309e-13,9.02213532 4.89386309e-13,6 C4.89386309e-13,2.97786468 2.23435588,0.477591146 5.14125587,0.0609911429 C3.092555,1.24697405 1.71428571,3.462531 1.71428571,6 Z",
    id: "Combined-Shape",
    opacity: 0.300000012
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14285714,6 C5.14285714,8.537469 6.52112642,10.753026 8.56987354,11.9388794 C5.66292731,11.5224089 3.42857143,9.02213532 3.42857143,6 C3.42857143,2.97786468 5.66292731,0.477591146 8.5698273,0.0609911429 C6.52112642,1.24697405 5.14285714,3.462531 5.14285714,6 Z",
    id: "Combined-Shape",
    opacity: 0.600000024
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.8571429,
    cy: 6,
    r: 6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnimateRight);
export default __webpack_public_path__ + "static/media/icon-animate-right.4200f65b78d80c3f130fcebf7a23b47c.svg";
export { ForwardRef as ReactComponent };